import React from "react";
import ReactWhatsapp from "react-whatsapp";

const LiveChat = () => {
  return (
    <div className="relative z-50">
      <div className=" right-[30px] bottom-[10%] fixed">
        <div className={`mb-5 `}>
          <ReactWhatsapp
            number="+8801540343775"
            message="How can I help you!!!"
          >
            <span className="flex bg-[#28D146] text-[30px] text-[#fff] justify-center items-center w-[60px] h-[60px] rounded-[100%]">
              <i className="fa-brands fa-whatsapp"></i>
            </span>
          </ReactWhatsapp>
        </div>
      </div>
    </div>
  );
};

export default LiveChat;
